import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ddd7a45"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal__header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "modal__title" }, "Как работать с картой", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ol", { class: "modal__list" }, [
  /*#__PURE__*/_createElementVNode("li", { class: "modal__list-item" }, [
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createElementVNode("strong", null, "Отметьте"),
      /*#__PURE__*/_createTextVNode(" на челюсти импланты и отсутствующие зубы. ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "modal__list-item" }, [
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createElementVNode("strong", null, "Выберите фирму ёршика."),
      /*#__PURE__*/_createTextVNode(" Затем цвет. Нажмите на кружок "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" между зубами в нужном месте. Кружок окрашен. ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "modal__list-item" }, [
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createElementVNode("strong", null, "Как показать направление стрелки на схеме?"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" Нажмите на окрашенный кружок: "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createElementVNode("span", { class: "top" }, "1 раз - стрелка снаружи"),
      /*#__PURE__*/_createTextVNode(" 2 раза - стрелка изнутри "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 3 раза - стрелка снаружи и изнутри "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 4 раза - стрелка исчезнет "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createElementVNode("span", { class: "top" }, "Действие можно повторить еще раз.")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "modal__list-item" }, [
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createElementVNode("strong", null, "Выбранные ёршики"),
      /*#__PURE__*/_createTextVNode(" автоматически отражаются внизу. ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "modal__list-item" }, [
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createElementVNode("strong", null, "Как отправить карту пациенту?"),
      /*#__PURE__*/_createTextVNode(" Если у пациента уже есть "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" телеграм бот DIANA, то карта ёршиков автоматически "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" появится в боте после сохранения карты. Если бота "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" нет - дайте пациенту отсканировать QR-код, который "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" появится после сохранения карты и она автоматически "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" будет отправлена пациенту. Либо нажмите «Скачать» и "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" отправьте пациенту в месенджер. ")
    ])
  ])
], -1))




export default /*#__PURE__*/_defineComponent({
  props: {
  isModalVisible: Boolean,
  isCreationDialogVisible: Boolean,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_icon_template = _resolveComponent("icon-template")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: __props.isModalVisible,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(isModalVisible) ? (isModalVisible).value = $event : null)),
    "show-close": false,
    width: "538"
  }, {
    header: _withCtx(({ close }) => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_icon_template, {
          class: "modal__header-icon",
          height: "25",
          name: "close",
          width: "25",
          onClick: close
        }, null, 8, ["onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _hoisted_3
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})